import { List } from './List';
import { ListItem } from './ListItem';
import { Separator } from './Separator';

interface WithLabel {
  'aria-label': string;
}

interface WithLabelledBy {
  'aria-labelledby': string;
}

type NavProps = WithLabel | WithLabelledBy;

const Root: React.FC<React.PropsWithChildren<NavProps>> = ({ children, ...ariaProps }) => (
  <nav {...ariaProps}>{children}</nav>
);

export const Nav = Object.assign(Root, {
  List,
  ListItem,
  Separator,
});
